import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import Home from './pages/Home';
import Legal from './pages/Legal';
import NotFound from './pages/NotFound';

import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Guide from "./pages/Guide";
import TopicPage from "./pages/TopicPage";
import { topicPages } from "./pages/topicPages";
import { appRoutes } from "./routes/publicRoutes";

const router = createBrowserRouter([
  ...appRoutes.map((route) => {
    if (route.key === "home") {
      return {
        path: route.path,
        element: <Home />,
      };
    }

    if (route.key === "guide") {
      return {
        path: route.path,
        element: <Guide />,
      };
    }

    if (route.key === "legal") {
      return {
        path: route.path,
        element: <Legal />,
      };
    }

    if (route.key === "topic") {
      return {
        path: route.path,
        element: <TopicPage page={route.page} allPages={topicPages} />,
      };
    }

    if (route.key === "notFound") {
      return {
        path: route.path,
        element: <NotFound />,
      };
    }

    return null;
  }).filter(Boolean),
  {
    path: "*",
    element: <NotFound />,
  },
]);

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
